 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import FRONTM from '@/components/frontm'
 import TITLE from '@/components/title'
 import COPYRIGHT from '@/components/copyright'
 import DEDI from '@/components/dedi'
 import CHAP1 from '@/components/chap1'
 import CHAP2 from '@/components/chap2'
 import CHAP3 from '@/components/chap3'
 import CHAP4 from '@/components/chap4'
 import CHAP5 from '@/components/chap5'
 import CHAP6 from '@/components/chap6'
 import CHAP7 from '@/components/chap7'
 import CHAP8 from '@/components/chap8'
 import CHAP9 from '@/components/chap9'
 import CHAP10 from '@/components/chap10'
 import CHAP11 from '@/components/chap11'
 import CHAP12 from '@/components/chap12'
 import CHAP13 from '@/components/chap13'
 import CHAP14 from '@/components/chap14'
 import CHAP15 from '@/components/chap15'
 import ACK from '@/components/ack'
 import ABOUT from '@/components/about'
 import BCKM from '@/components/bckm'
 import BCK2 from '@/components/bck2'
 import BACKCOVER from '@/components/backcover'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/frontm",
 			"name" : "frontm",
 			"component" : FRONTM
 		},
 		{
 			"path" : "/title",
 			"name" : "title",
 			"component" : TITLE
 		},
 		{
 			"path" : "/copyright",
 			"name" : "copyright",
 			"component" : COPYRIGHT
 		},
 		{
 			"path" : "/dedi",
 			"name" : "dedi",
 			"component" : DEDI
 		},
 		{
 			"path" : "/chap1",
 			"name" : "chap1",
 			"component" : CHAP1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js